/*
 * Copyright 2019 FedEx
 */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GetAwbDetailsService {

  constructor(private httpObj: HttpClient) { }

  getAwbDetails(uniqueIdForAwb: string, oauthToken: string) {
    //let requestURL: string;
    const requestUrl = environment.baseUrl + environment.docUploadContext + environment.GET_AWB_DETAILS_API_URL + uniqueIdForAwb;
    //requestURL = requestUrl + uniqueIdForAwb;
    return this.httpObj.get(requestUrl, this.setOptions(oauthToken));
  }

  getDocument(oauthToken: string, awb: string, docType: string) {
    const requestUrl = environment.baseUrl + environment.docUploadContext + environment.GET_DOCUMENT + "/" + awb + "/" + docType;
    // let requestURL: string;
    // requestURL = requestUrl + "/" + awb + "/" + docType;
    return this.httpObj.get<any>(requestUrl, this.setOptions(oauthToken));
  }

  //country config
  getCountryBasedReasonDetails(countryCode: string, oauthToken: string) {
    //let requestURL: string;
    const requestURL = environment.baseUrl + environment.docUploadContext + environment.GET_CTRY_BASED_REASON_CODE + countryCode;
    return this.httpObj.get(requestURL, this.setOptions(oauthToken));
  }
  //country config

  setOptions(oauthToken: string) {
    const oauthHeader = new HttpHeaders({
      'apikey': oauthToken
    });
    const options = { headers: oauthHeader };
    return options;
  }

}
